<template>
  <b-overlay :opacity="'0.5'" :show="onGoingCalls > 0" rounded="sm">
    <div>
      <link rel="stylesheet" :href="require('../../../../assets/css/vue-select.css')">
      <div class="settings-row" style="padding: 5px auto; margin-bottom: 0 !important; margin-top: 0 !important; background-color: #F7F7F7;">
        <i class="mdi mdi-cog" aria-hidden="true"></i>&nbsp;{{ $t('settings.settings') }}
      </div>
      <div style="height: 528px; width: 240px; overflow-y: scroll; padding: 0 30px 0 30px; background-color: #FFFFFF;">
        <div class="settings-sub-row" style="background-color: #009AB1; color: white; padding: 10px 10px; text-align: center !important;">
          <span>
            {{ name }}
            <span style="font-size: 0.9rem;" v-if="extension && !disableSpeedDial"><br />{{ $t('settings.extension') }}: {{ extension }}</span>
            <span style="font-size: 0.9rem;" v-if="fonenumber"><br />{{ $t('settings.callerID') }}: {{ fonenumber }}</span>
          </span>
        </div>
        <div class="settings-sub-row settings-sub-row-hover" @click="showFones" v-if="!fractelfone && !disableDirectory">
          <span>
            <i class="mdi mdi-swap-horizontal-variant" aria-hidden="true"></i>&nbsp;{{ $t('settings.switch', { appName: $whitelabel.getAppName() }) }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="fones">
            <v-select
              v-model="device"
              v-bind:options="devices"
              :clearable="false"
              :loading="foneProcessing"
              @input="switchFone"
              >
              <template #spinner="{ loading }">
                <div v-if="foneProcessing" style="border-left-color: rgba(0,154,177,0.71)" class="vs__spinner">
                </div>
              </template>
            </v-select>
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showCallerID" v-if="!disableDirectory && canEditCallerID">
          <span>
            <i class="mdi mdi-numeric" aria-hidden="true"></i>&nbsp;{{ $t('settings.callerID') }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="callerID">
            <v-select
              v-model="fonenumber"
              v-bind:options="fonenumbers"
              :clearable="false"
              :loading="processing"
              @input="fonenumberSelect"
              >
              <template #spinner="{ loading }">
                <div v-if="processing" style="border-left-color: rgba(0,154,177,0.71)" class="vs__spinner">
                </div>
              </template>
            </v-select>
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showTimes">
          <span>
            <i class="mdi mdi-clock" aria-hidden="true"></i>&nbsp;{{ $t('settings.timeFormat') }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="timeFormating">
            <v-select
              v-model="timeFormat"
              v-bind:options="timeFormats"
              :clearable="false"
              @input="switchTimeFormat"
              />
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showDND">
          <span>
            <i class="mdi mdi-minus-circle" aria-hidden="true"></i>&nbsp;{{ $t('settings.doNotDisturb') }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="editDND">
            <v-select
              v-model="DND"
              v-bind:options="DNDoptions"
              :clearable="false"
              @input="switchDND"
              />
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showCallWaiting">
          <span>
            <i class="mdi mdi-human-queue" aria-hidden="true"></i>&nbsp;{{ $t('settings.callWaiting') }}
          </span>
        </div>
        <transition name="fade">
          <div class="settings-sub-row settings-sub-row-hover" v-if="editCallWaiting">
            <v-select
              v-model="callWaiting"
              v-bind:options="callWaitingOptions"
              :clearable="false"
              @input="switchCallWaiting"
              />
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="showCallForwarding">
          <span>
            <i class="mdi mdi-phone-forward" aria-hidden="true"></i>&nbsp;{{ $t('settings.callForwarding') }}
          </span>
        </div>
        <transition name="fade">
          <div v-if="editCallForwarding">
          <b-form @submit="forwardCalls">
            <v-select placeholder="Select an option" @input="callForwardingOptions" v-model="selected" :options="['Never', 'Always', 'Schedule']"></v-select>
            <b-form-group v-if="this.selected=='Schedule'">
              <label for="start_time">Choose Start Time:</label>
              <b-form-timepicker
                v-model="start_time"
                id="start_time"
                placeholder="Start Time"
                now-button
                locale="en"
                @hidden="forwardCalls"
              ></b-form-timepicker>
            </b-form-group>
            <b-form-group v-if="start_time && this.selected=='Schedule'">
              <label for="end_time">Choose End Time:</label>
              <b-form-timepicker
                v-model="end_time"
                id="end_time"
                placeholder="End Time"
                now-button
                locale="en"
                @hidden="forwardCalls"
              ></b-form-timepicker>
            </b-form-group>
            <b-form-group
              v-if="(start_time && end_time && this.selected=='Schedule')|| this.selected=='Always'"
              id="forward-number"
              description="Enter Forwarding Number."
              label="Forwarding Number:"
              label-for="forward-number"
              valid-feedback="Valid number."
              :invalid-feedback="invalidFeedback"
              :state="state"
            >
              <b-form-input id="forwardNumber" v-model="forwardNumber" @blur="forwardCalls" :state="state" trim></b-form-input>
            </b-form-group>
          </b-form>
          </div>
        </transition>
        <div class="settings-sub-row settings-sub-row-hover" @click="logout">
          <span>
            <i class="mdi mdi-logout" aria-hidden="true"></i>&nbsp;{{ $t('settings.logout') }}
          </span>
        </div>
      </div>
    </div>
    <template v-slot:overlay>
      <div class="text-center">
        <span><b-spinner variant="teal" type="grow" small></b-spinner>{{ $t('settings.onCall') }}...</span>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'

export default {
  name: 'Settings',
  components: {
    'v-select': vSelect
  },
  mounted: async function () {
    var self = this
    try {
      var userAgent = navigator.userAgent
      if (userAgent.match(/Windows/i)) {
        if (userAgent.match(/Edge/i)) {
          self.isEdge = true
        } else {
          self.isWChrome = true
        }
      }

      self.processing = true
      self.foneProcessing = true
      self.device = {
        label: self.name,
        code: localStorage.getItem('device')
      }

      let response = await axios.get(`${process.env.FONESTORM_API}/devices/${localStorage.getItem('device')}/verto`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.fonenumber = response.data.device.fonenumber

      const res = await axios.get(`${process.env.FONESTORM_API}/devices/${localStorage.getItem('device')}`, { headers: { token: localStorage.getItem('fonestorm-token') } })

      const forwardall_settings=res.data.device.forwardall_settings
      console.log('forwardall_settings', forwardall_settings)
      self.forwardNumber = forwardall_settings.phonenumber
      self.start_time = forwardall_settings.start_time
      self.end_time = forwardall_settings.end_time
      if (self.forwardNumber) {
        if (self.start_time && self.end_time) {
          self.selected = 'Schedule'
        } else {
          self.selected = 'Always'
        }
      } else {
        self.selected = 'Never'
      }
      if (!self.disableDirectory) {
        response = await axios.get(`${process.env.FONESTORM_API}/fonenumbers?active=yes`, { headers: { token: localStorage.getItem('fonestorm-token') } })
        self.fonenumbers = response.data.fonenumbers
        response = await axios.get(`${process.env.FONESTORM_API}/devices`, { headers: { token: localStorage.getItem('fonestorm-token') } })
        response.data.devices.forEach((device) => {
          if (device.type === 'fractelfone' || device.type === 'webrtc device') {
            self.devices.push({
              label: device.name,
              code: device.id
            })
          }
        })
      }

      self.processing = false
      self.foneProcessing = false
    } catch (error) {
      self.processing = false
      self.foneProcessing = false
      if (error && error.response && error.response.status === 401) {
        self.$router.push({ name: 'Login' })
      }
    }
  },
  props: {
    name: {
      type: String,
      required: false
    },
    extension: {
      type: String,
      required: false
    },
    windowWidth: {
      type: Number
    },
    onGoingCalls: {
      type: Number,
      default: 0
    },
    vertoHandle: {
      type: Object,
      required: true
    },
    fractelfone: {
      type: String
    },
    io: {
      type: Object
    },
    DNDchange: {
      type: Function
    },
    disableSpeedDial: {
      type: Boolean
    },
    disableDirectory: {
      type: Boolean
    },
    CallWaitingChange: {
      type: Function
    },
    FWDchange: {
      type: Function
    },
    canEditCallerID: {
      type: Boolean
    }
  },
  computed: {
      state() {
      var self = this
        if (self.forwardNumber.length < 1 || self.forwardNumber.length > 20 || !/^([0-9\(\)\/\.\+ \-]*)$/.test(self.forwardNumber)){
          return false
       } else {
        return true
        }
      },
      invalidFeedback() {
        return 'Invalid number'
      }
    },
  data () {
    return {
      fonenumber: null,
      fonenumbers: [],
      device: null,
      devices: [],
      timeFormat: localStorage.getItem('timeFormat') === 'true' ? '12 hour' : '24 hour',
      timeFormats: ['24 hour', '12 hour'],
      DNDoptions: ['On', 'Off'],
      callerID: false,
      fones: false,
      timeFormating: false,
      processing: false,
      foneProcessing: false,
      editDND: false,
      DND: localStorage.getItem('DND') || 'Off',
      callWaiting: localStorage.getItem('CallWaiting') || 'Silent',
      callWaitingOptions: ['Silent', 'Ring', 'Reject'],
      editCallWaiting: false,
      editCallForwarding: false,
      start_time: '',
      end_time: '',
      forwardNumber: '',
      selected: null,
      isWChrome: false,
      isEdge: false
    }
  },
  methods: {
    fonenumberSelect: async function() {
      var self = this

      try {
        if (self.fonenumber) {
          self.processing = true
          await axios.put(`${process.env.FONESTORM_API}/devices/${localStorage.getItem('device')}`, { fonenumber: self.fonenumber },{ headers: { token: localStorage.getItem('fonestorm-token') } })
          self.processing = false
        }
      } catch (error) {
        self.processing = false
        if (error && error.response && error.response.status === 401) {
          self.$router.push({ name: 'Login' })
        }
      }
    },
    showCallerID () {
      var self = this
      self.fones = false
      self.timeFormating = false
      self.editDND = false
      self.editCallWaiting = false
      self.editCallForwarding = false
      self.callerID = !self.callerID
    },
    switchFone () {
      var self = this
      localStorage.setItem('device', self.device.code)
      if (self.windowWidth < 800) {
        if (self.isWChrome) {
          window.resizeTo(436, 610)
        } else {
          window.resizeTo(420, 610)
        }
      }
      self.$router.go()
    },
    showFones () {
      var self = this
      self.callerID = false
      self.timeFormating = false
      self.editDND = false
      self.editCallWaiting = false
      self.editCallForwarding = false
      self.fones = !self.fones
    },
    switchTimeFormat () {
      var self = this
      var ampm = self.timeFormat === '12 hour'
      localStorage.setItem('timeFormat', ampm)
    },
    showTimes () {
      var self = this
      self.callerID = false
      self.fones = false
      self.editDND = false
      self.editCallWaiting = false
      self.editCallForwarding = false
      self.timeFormating = !self.timeFormating
    },
    switchDND () {
      var self = this
      self.DNDchange(self.DND)
      localStorage.setItem('DND', self.DND)
    },
    showDND () {
      var self = this
      self.callerID = false
      self.fones = false
      self.timeFormating = false
      self.editCallWaiting = false
      self.editCallForwarding = false
      self.editDND = !self.editDND
    },
    switchCallWaiting () {
      var self = this
      self.CallWaitingChange(self.callWaiting)
      localStorage.setItem('CallWaiting', self.callWaiting)
    },
    showCallWaiting () {
      var self = this
      self.callerID = false
      self.fones = false
      self.timeFormating = false
      self.editDND = false
      self.editCallForwarding = false
      self.editCallWaiting = !self.editCallWaiting
    },
     showCallForwarding () {
      var self = this
      self.callerID = false
      self.fones = false
      self.timeFormating = false
      self.editDND = false
      self.editCallWaiting = false
      self.editCallForwarding = !self.editCallForwarding
    },
    logout () {
      var self = this
      if (self.windowWidth < 800) {
        if (self.isWChrome) {
          window.resizeTo(436, 610)
        } else {
          window.resizeTo(420, 610)
        }
      }
      self.vertoHandle.rpcClient.closeSocket()
      self.vertoHandle.rpcClient.stopRetrying()
      self.io.disconnect()
      self.$router.push({ name: 'Login' })
    },
    forwardCalls: async function() {
      var self = this
      try {
        if (self.state || self.selected == "Never") {
          localStorage.setItem('CallForwarding', self.selected)
          self.processing = true
          if(self.selected =="Never"){
            self.FWDchange(false)
          }
          if(self.selected =="Always"){
            self.FWDchange(true)
          } if (self.selected == "Schedule") {
            var today = new Date()
            const now = today.getHours() + ':' + today.getMinutes()
              if (self.start_time < now) {
                console.log('start time is before now')
                if (self.end_time > now) {
                  self.FWDchange(true)
                  console.log('end time is after now')
                  } else { self.FWDchange(false) }
                } else { self.FWDchange(false) }
            }
          self.forwardNumber = self.forwardNumber.replace(/\D/g,'');
          console.log('striped forward#', this.forwardNumber)
          await axios.put(`${process.env.FONESTORM_API}/devices/${localStorage.getItem('device')}`,
          {forwardall_settings: {
            phonenumber: self.forwardNumber,
            start_time: self.alwaysForward? "": self.start_time.length == 5? self.start_time: self.start_time.length > 5? self.start_time.slice(0,-3): "",
            end_time: self.alwaysForward? "": self.end_time.length == 5? self.end_time: self.end_time.length > 5? self.end_time.slice(0,-3): ""
            }
          },{ headers: { token: localStorage.getItem('fonestorm-token') } })
              self.processing = false
              console.log("forwardAll settings updated")
        }
      } catch (error) {
        self.processing = false
        console.log('forwardall error',error)
        if (error && error.response && error.response.status === 401) {
          //self.$router.push({ name: 'Login' })
        }
      }
    },
    callForwardingOptions(){
      var self = this
      localStorage.setItem('CallForwarding', self.selected)
      if (self.selected == "Never"){
        self.FWDchange(false)
        self.forwardNumber=""
        self.start_time=""
        self.end_time=""
        self.forwardCalls()
        console.log('forward Message off')
      } else if (self.selected == "Always"){
          if (self.state) {
            self.FWDchange(true)
            self.start_time=""
            self.end_time=""
            self.forwardCalls()
          }
        }
    }
  }
}

</script>

<style lang="scss">
.settings-row {
  margin: 20px auto !important;
  width: auto;
  max-width: 420px !important;
  height: auto !important;
  clear: both !important;
}

.settings-sub-row {
  margin: 20px auto !important;
  width: auto;
  max-width: 420px !important;
  height: auto !important;
  clear: both !important;
  text-align: left !important;
}

.settings-sub-row-hover:hover {
  color: #009AB1 !important;
  cursor: pointer;
}

.vs__dropdown-menu {
  max-height: 200px !important;
}

.vs__dropdown-option--highlight {
  background-color: #009AB1 !important;
}

.text-teal {
  color: #009AB1;
}
</style>
